<template>
  <lazy-div :load="doInit">
    <v-flex>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
        <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
        <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
        <v-toolbar-title v-if="tranMode === 'New'">New Default Text per Policy Type</v-toolbar-title>
        <v-toolbar-title v-if="tranMode === 'Review'">Edit Default Text per Policy Type</v-toolbar-title>
        <v-toolbar-title v-if="tranMode === 'Query'">View Default Text per Policy Type</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.scrRef }}</v-subheader>
              <div class="queryValue">{{ polTypeDefTxtForm.scrRef }} - {{ getScrRef(polTypeDefTxtForm.scrRef) }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.txtRef }}</v-subheader>
              <div class="queryValue">{{ polTypeDefTxtForm.txtRef }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="tranMode === 'New'">
              <v-autocomplete
                :items="polTypeList"
                v-model="polTypeDefTxtForm.polType"
                :label="labels.polType"
                item-text="label"
                item-value="value"
                data-vv-name="polType"
                :data-vv-as="labels.polType"
                :error-messages="errors.collect('polType')"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.polType }}</v-subheader>
              <div class="queryValue">{{ polTypeDefTxtForm.polType }} - {{ polTypeDefTxtForm.polTypeDesc }}</div>
            </v-flex>
            <v-flex xs6 v-if="polTypeDefTxtForm.scrRef !== '02'">
              <v-checkbox
                :label="labels.txtDef"
                v-model="polTypeDefTxtForm.txtDef"
                :error-messages="errors.collect('txtDef')"
                data-vv-name="txtDef"
                :data-vv-as="labels.txtDef"
                :disabled="tranMode === 'Query'"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ polTypeDefTxtForm.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ polTypeDefTxtForm.createdDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="tranMode !== 'New'">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ polTypeDefTxtForm.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ polTypeDefTxtForm.modifiedDate | formatDate }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
      <v-btn v-if="tranMode !== 'Query'" color="primary" dark class=" mr-2" @click="doSave">
        Save
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
    </v-flex>
  </lazy-div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { scrRef } from '@/const/params'
export default {
  data() {
    return {
      labels: {
        scrRef: 'Screen Reference',
        txtRef: 'Text Reference',
        polType: 'Policy Type',
        txtDef: 'Default Text',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      polTypeDefTxtForm: {
        scrRef: null,
        txtRef: null,
        polType: null,
        polTypeDesc: null,
        txtDef: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      polTypeList: null
    }
  },
  created() {},
  methods: {
    async doInit() {
      await this.getPolTypeList()
      if (!this.newPolTypeDefTxt && this.id.polType) {
        const apiURI = this.menu.getPolTypeDefTxt
        if (apiURI) {
          try {
            const result = await this.$http.get(expandURI(apiURI, this.id))
            const { data } = result.data
            if (data) {
              this.polTypeDefTxtForm.scrRef = data.polTypeDefTxt.scrRef
              this.polTypeDefTxtForm.txtRef = data.polTypeDefTxt.txtRef
              this.polTypeDefTxtForm.polType = data.polTypeDefTxt.polType
              if (data.polType) {
                this.polTypeDefTxtForm.polTypeDesc = data.polType.polTypeDesc
              }
              this.polTypeDefTxtForm.txtDef = data.polTypeDefTxt.txtDef
              this.polTypeDefTxtForm.createdBy = data.createdBy
              this.polTypeDefTxtForm.createdDate = data.createdDate
              this.polTypeDefTxtForm.modifiedBy = data.modifiedBy
              this.polTypeDefTxtForm.modifiedDate = data.modifiedDate
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.polTypeDefTxtForm.scrRef = this.id.scrRef
        this.polTypeDefTxtForm.txtRef = this.id.txtRef
        this.polTypeDefTxtForm.polType = null
        this.polTypeDefTxtForm.txtDef = false
        this.polTypeDefTxtForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.polTypeDefTxtForm.createdDate = new Date()
      }
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          const config = {
            method: this.newPolTypeDefTxt ? 'post' : 'put',
            url: this.newPolTypeDefTxt ? this.menu.createPolTypeDefTxt : this.menu.updatePolTypeDefTxt,
            data: this.polTypeDefTxtForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.$emit('close')
                this.$emit('fetch')
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    getScrRef(value) {
      return scrRef[value]
    },
    async getPolTypeList() {
      const apiURI = this.menu.polTypeList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.polTypeList = data
          this.polTypeList.splice(0, 1)
        } catch (err) {
          this.polTypeList = []
        }
      } else {
        this.polTypeList = []
      }
    },
    doCancel() {
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.docFormatParam.menu
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  mixins: [MessageMixin],
  props: ['id', 'newPolTypeDefTxt', 'tranMode']
}
</script>

<style>
</style>
